import { map, prop } from 'ramda';

import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

export const mapTeethToIds = map<Tooth, string>(prop<keyof Tooth>('ID'));
